import Vue from 'vue';
import Router from 'vue-router';
import store from './store'
import I18n from './components/HelloI18n.vue';
import Login from './views/Login.vue';
import Layout from './views/Layout.vue';
import Boxlist from './views/box/Boxlist.vue'
import Boxlog from './views/box/Boxlog.vue'
import Unitlist from './views/unit/Unitlist.vue'
import Myauth from './views/myauth/Myauth.vue'
import Version from './views/version/Version.vue'
import User from './views/user/User.vue'
import Statistics from './views/manage/Statistics.vue'
import Search from './views/manage/Search.vue'
import Timerlog from './views/manage/Timerlog.vue'
import Operationlog from './views/manage/Operationlog.vue'
import Help from './views/help/Help'
import HelpHome from './views/help/components/helpHome'
import HelpBeginSession from './views/help/components/helpBeginSession'
import HelpEndSession from './views/help/components/helpEndSession'
import HelpEndSessions from './views/help/components/helpEndSessions'
import HelpGetBoxs from './views/help/components/helpGetBoxs'
import HelpGetSessionRsts from './views/help/components/helpGetSessionRsts'
import HelpJoininSession from './views/help/components/helpJoininSession'
import HelpJoinoutSession from './views/help/components/helpJoinoutSession'
import HelpSetBox from './views/help/components/helpSetBox'
import HelpSetBoxs from './views/help/components/helpSetBoxs'
import BoxlogNew from './views/box/BoxlogNew.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: Layout,
      redirect: '/boxlist',
      beforeEnter(to, from, next) {
        if (store.state.user_id) {
          next();
        } else {
          store.dispatch('setCallbackUrl', to.path)
          next({
            name: 'login'
          })
        }
      },
      children: [
        {
          path: '/intl',
          name: 'intl',
          component: I18n,
        },
        {
          path: '/boxlist',
          name: 'boxlist',
          component: Boxlist,
        },
        {
          path: '/boxlog/:boxsn',
          name: 'boxlog',
          component: Boxlog,
        },
        {
          path:'/boxlognew/:boxsn',
          name:'boxlognew',
          component:BoxlogNew
        },
        {
          path: '/unitlist',
          name: 'unitlist',
          component: Unitlist,
        },
        {
          path: '/myauth',
          name: 'myauth',
          component: Myauth,
        },
        {
          path: '/version',
          name: 'version',
          component: Version,
        },
        {
          path: '/user',
          name: 'user',
          component: User,
        },
        {
          path: '/statistics',
          name: 'statistics',
          component: Statistics,
        },
        {
          path: '/search',
          name: 'search',
          component: Search,
        },
        {
          path: '/timerlog',
          name: 'timerlog',
          component: Timerlog,
        },
        {
          path: '/operationlog',
          name: 'operationlog',
          component: Operationlog,
        },
        {
          path: '/help',
          component: Help,
          children: [{
                path: '',
                component: HelpHome
          }, {
                path: 'beginSession',
                component: HelpBeginSession
          }, {
                path: 'endSession',
                component: HelpEndSession
          }, {
                path: 'endSessions',
                component: HelpEndSessions
          }, {
                path: 'getBoxs',
                component: HelpGetBoxs
          }, {
                path: 'getSessionRsts',
                component: HelpGetSessionRsts
          }, {
                path: 'joininSession',
                component: HelpJoininSession
          }, {
                path: 'joinoutSession',
                component: HelpJoinoutSession
          }, {
                path: 'setBox',
                component: HelpSetBox
          },{
                path: 'setBoxs',
                component: HelpSetBoxs
          }]
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter(to, from, next) {
        if (store.state.user_id) {
          next({
            name: from.name
          })
        } else {
          next()
        }
      },
    },
  ],
});
